export default {"src":"/_next/static/media/polygon.237cd2b6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};